<template>
  <ModalDialog
    ref="dialog"
    title="Recut Panel"
    icon="fa-sync"
    :showFooter="true"
    :scrollable="false"
    :submitDisabled="false"
    :submitting="submitting"
    submitTitle="Recut Panel"
    @closed="onClosed"
    @submitted="onSubmitted">

    <Spinner v-if="loading" />
    <div class="text-center text-danger" v-if="loadingError">{{loadingError}}</div>
    <div v-if="!loading && productionPanelData">
      <FormGroup v-bind:form="form" :labelColumnSize="3">
        <FormRow label="Panel Details">
          <FormStaticLabel>
            {{productionPanelData.barcode}}<br />
            {{productionPanelData.orderItem.stock.code}} - {{productionPanelData.orderItem.stock.name}}<br />
            {{productionPanelData.panelHeight}} x {{productionPanelData.panelWidth}}
          </FormStaticLabel>
        </FormRow>
        <FormRow label="Order">
          <FormStaticLabel>#{{productionPanelData.order.sequenceNumber}}</FormStaticLabel>
        </FormRow>
        <FormRow label="Customer">
          <FormStaticLabel>{{productionPanelData.order.contact.name}}</FormStaticLabel>
        </FormRow>
        <FormHorizontalRule />
        <FormRow label="Reporting User">
          <FormInputText ref="reportingUserInput" v-model="recut.reportingUser" placeholder="Reporting User" field="reportingUser" />
        </FormRow>
        <FormRow label="Notes">
          <FormInputTextArea v-model="recut.notes" placeholder="Notes" field="notes" />
        </FormRow>
        <FormRow label="Recut Labels">
          <FormLabelTag popupName="Recut Labels" v-model="recut.labelList" labelType="productionPanelRecut" field="labelList" />
        </FormRow>      
        
      </FormGroup>
    </div>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'RecutPanelDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    productionStationId: Number,
    productionPanelId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      recut: {
        labelList: []
      },
      productionPanelData: null,
      form: {},
      submitting: false
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    
  },
  methods: {
    show() {
      this.form = {}
      this.recut = {
        labelList: []
      }
      this.submitting = false

      this.requestPanelData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.confirmDeleteMessage('Recut Panel?', 'Are you sure you want to recut this panel? This action cannot be undone')
      .then(success => {
        if(success) {
          // Send recut request
          this.form = this.clearFormResponse()

          var recutData = {
            productionPanelId: this.productionPanelId,
            reportingUser: this.recut.reportingUser,
            notes: this.recut.notes,
            labelList: this.recut.labelList.map(label => label.id)
          }

          this.submitting = true
          this.$apiService.glassProductionStationService.recutPanel(this.productionStationId, recutData)
          .then(response => {
            this.modalClosed(response.data)
            this.hide()
          })
          .catch(err => {
            this.form = this.processFormResponse(err)
          })
          .finally(() => {
            this.submitting = false
          })
        }
      })
    },

    requestPanelData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.glassProductionStationService.getProductionPanel(this.productionPanelId)
      .then(response => {
        this.productionPanelData = response.data
        this.loading = false

        this.$nextTick(() => {
          this.$refs.reportingUserInput.focus()
        })
      })
      .catch(err => {
        this.loadingError = 'Error loading panel data'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>